// extracted by mini-css-extract-plugin
export default {"documentationList":"NavbarItemDocumentation_documentationList__rxCpw","item":"NavbarItemDocumentation_item__fHldT","active":"NavbarItemDocumentation_active__YLTNV"};